/* Native Oak & Lily cart with Optimistic UI, Stepper Debouncing & Micro-DOM Patching */
(()=>{
if(window.oakNativeCartReady)return;window.oakNativeCartReady=true;
const root=window.Shopify?.routes?.root||'/';
let previousLevel=null;
let confirmedLevel=null; // reward level Shopify last confirmed
let celebratedLevel=0; // highest level already celebrated; reset when the cart drops below it, so a milestone pops once per crossing
let shownLevel=null; // level celebrated instantly from the tap, before Shopify confirmed it
let tapPopTimer=null,tapPopBase=null,tapPopSavings=null; // celebrate only once a burst of taps settles
const pendingChangeTimers={};
const pendingQuantities={};
const inFlightChanges={};
const quantityRequestVersions={};
const stableItemId=key=>String(key||'').split(':')[0];
// Each drawer line gets its own id. The same variant can sit on several lines (Build Your Bundle properties, gifts),
// so the variant id alone can't tell lines apart: a tap on one line used to change another.
let lineUidSeq=0;
const lineUid=card=>card?(card.dataset.lineUid||(card.dataset.lineUid='l'+(++lineUidSeq))):'';

const money=n=>new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:2}).format(n/100);
const formatInr=n=>'₹ '+new Intl.NumberFormat('en-IN',{maximumFractionDigits:2,minimumFractionDigits:2}).format(n/100);

// Progress value: the estimated total (after discounts).
function progressTotal(box){
 return Number(box.dataset.progressTotal!==undefined?box.dataset.progressTotal:box.dataset.cartTotal)||0;
}
const tier1Blocked=box=>box?.dataset.tier1Blocked==='true';
const tier1Applied=box=>box?.dataset.tier1Applied==='true';

function milestones(celebrateFrom=null,customSavings=null){
 const box=document.querySelector('[data-cart-rewards]');if(!box)return;
 const total=progressTotal(box),applied=tier1Applied(box),tiers=box.dataset.thresholds.split(',').map(Number),positions=[100/6,50,500/6];
 // Milestones follow the estimated total. 10% OFF also counts as reached when it is applied
 // (it can take the total under its own threshold).
 const reached=tiers.map((t,i)=>i===0?(applied||total>=t):total>=t);
 const level=reached.filter(Boolean).length;let progress=100;
 for(let i=0;i<tiers.length;i++){if(total<tiers[i]){const a=i?tiers[i-1]:0,b=i?positions[i-1]:0;progress=b+(total-a)/(tiers[i]-a)*(positions[i]-b);break;}}
 if(reached[0])progress=Math.max(progress,positions[0]);
 const fill=box.querySelector('[data-reward-fill]');
 if(fill)fill.style.width=Math.max(0,Math.min(100,progress))+'%';
 box.querySelectorAll('[data-reward-node]').forEach((node,i)=>node.classList.toggle('is-unlocked',!!reached[i]));
 const names=[box.dataset.tier1Headline||((box.dataset.discountPercent||10)+'% OFF'),box.dataset.tier2Headline||'Free Napkins',box.dataset.tier3Headline||'Gift Hamper'];
 const headline=box.querySelector('[data-reward-headline]');
 if(headline){
  let next=reached.findIndex(r=>!r);
  headline.textContent=next<0?'You have unlocked all reward milestones!':'Get '+names[next]+' by adding items worth '+money(Math.max(0,tiers[next]-total));
 }
 if(level<celebratedLevel)celebratedLevel=level;
 if(celebrateFrom!==null&&level>celebrateFrom)triggerCelebration(level,customSavings);
 previousLevel=level;
 return level;
}

function clearStatus(){
 document.querySelector('[data-cart-status]')?.remove();
}

function message(text){
 clearStatus();
 if(!text)return;
 const el=document.createElement('p');el.dataset.cartStatus='';el.setAttribute('role','status');
 el.style.cssText='margin:8px 15px;color:#103f56;font-size:13px';
 document.querySelector('.cart-coupon-box')?.after(el);
 el.textContent=text;
 setTimeout(()=>el.remove(),4000);
}

const CONFETTI_COLORS=['#E9BF20','#2E7D32','#123F57','#F4D35E','#B7EBC8','#FFFFFF'];
let confettiFrame=null,confettiParticles=[],confettiStart=0;
function stopConfetti(){
 if(confettiFrame)cancelAnimationFrame(confettiFrame);
 confettiFrame=null;confettiParticles=[];
 const canvas=document.querySelector('#celebration-confetti-canvas');
 if(canvas){const ctx=canvas.getContext('2d');ctx.clearRect(0,0,canvas.width,canvas.height);}
}

function startConfetti(){
 stopConfetti();
 const canvas=document.querySelector('#celebration-confetti-canvas'),drawer=document.querySelector('#CartDrawer');
 if(!canvas||!drawer||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 const rect=drawer.getBoundingClientRect(),dpr=Math.min(window.devicePixelRatio||1,2);
 canvas.width=Math.max(1,Math.floor(rect.width*dpr));canvas.height=Math.max(1,Math.floor(rect.height*dpr));
 const ctx=canvas.getContext('2d');ctx.scale(dpr,dpr);
 const w=rect.width,h=rect.height;
 confettiParticles=Array.from({length:65},(_,i)=>({
  x:Math.random()*w,y:-20-Math.random()*h*.3,
  vx:(Math.random()-.5)*1.6,vy:2.4+Math.random()*2.8,
  size:5+Math.random()*6,rotation:Math.random()*Math.PI*2,
  vr:(Math.random()-.5)*.16,wobble:Math.random()*Math.PI*2,
  color:CONFETTI_COLORS[i%CONFETTI_COLORS.length],alpha:1
 }));
 confettiStart=performance.now();
 const draw=now=>{
  const elapsed=now-confettiStart;
  ctx.clearRect(0,0,w,h);
  confettiParticles.forEach(p=>{
   p.x+=p.vx+Math.sin(p.wobble+elapsed*.004)*.4;
   p.y+=p.vy;p.vy=Math.min(p.vy+.03,5.2);
   p.rotation+=p.vr;p.wobble+=.03;
   if(elapsed>2400)p.alpha=Math.max(0,1-(elapsed-2400)/800);
   if(p.y>h+20)p.y=-20;
   ctx.save();ctx.globalAlpha=p.alpha;ctx.translate(p.x,p.y);ctx.rotate(p.rotation);
   ctx.fillStyle=p.color;ctx.fillRect(-p.size/2,-p.size*.32,p.size,p.size*.64);ctx.restore();
  });
  if(elapsed<3200)confettiFrame=requestAnimationFrame(draw);else stopConfetti();
 };
 confettiFrame=requestAnimationFrame(draw);
}

function triggerCelebration(level,customSavings=null){
 const sheet=document.querySelector('#milestone-celebration');if(!sheet)return;
 if(level<=celebratedLevel)return; // already celebrated this crossing (tap estimate, then Shopify's confirm)
 celebratedLevel=level;
 const box=document.querySelector('[data-cart-rewards]');
 // Celebrate whenever the 10% OFF node ticks, also when the napkin offer saves more (Arpit 17:22).
 const names=[box?.dataset.tier1Headline||((box?.dataset.discountPercent||10)+'% OFF'),box?.dataset.tier2Headline||'Free Napkins',box?.dataset.tier3Headline||'Gift Hamper'];
 const head='Woohoo!';
 const copy=[
  [head,'You just unlocked '+names[0]+' on your order!'],
  [head,'You just unlocked '+names[1]+' with your purchase!'],
  [head,'You just unlocked '+names[2]+' with your purchase!']
 ][Math.max(0,Math.min(2,level-1))];
 sheet.querySelector('[data-celebration-headline]').textContent=copy[0];
 sheet.querySelector('[data-celebration-subline]').textContent=copy[1];
 sheet.querySelector('[data-celebration-reward]').textContent=names[Math.max(0,Math.min(2,level-1))];
 const savings=sheet.querySelector('[data-celebration-savings]');
 const couponVal=document.querySelector('[data-coupon-savings-val]')?.textContent?.trim();
 const footerVal=document.querySelector('[data-footer-savings-val]')?.textContent?.trim();
 const cartSavings=customSavings||(couponVal&&couponVal!=='₹ 0.00'?couponVal:footerVal);
 if(savings&&cartSavings)savings.textContent=cartSavings;
 shownLevel=level;
 sheet.classList.add('is-active');sheet.setAttribute('aria-hidden','false');
 startConfetti();
 const button=sheet.querySelector('[data-celebration-dismiss]');
 if(button){
  button.onclick=event=>{event.preventDefault();event.stopPropagation();dismissCelebration();};
  button.focus();
 }
 sheet.onclick=event=>{if(event.target===sheet)dismissCelebration();};
}

function dismissCelebration(){
 shownLevel=null;
 const sheet=document.querySelector('#milestone-celebration');sheet?.classList.remove('is-active');sheet?.setAttribute('aria-hidden','true');stopConfetti();
}

function syncOptimisticCart(clickedCard,itemKey,targetQty){
 const clickedUid=lineUid(clickedCard);
 const qtyEl=clickedCard.querySelector('[data-item-qty]');
 if(qtyEl)qtyEl.textContent=targetQty;
 clickedCard.style.opacity=targetQty===0?'0.35':'1';

 const box=document.querySelector('[data-cart-rewards]');
 const tiers=box?box.dataset.thresholds.split(',').map(Number):[110000,159900,299900];
 const allCards=document.querySelectorAll('.cart-item-card');

 let totalSubtotal=0;
 let totalCompare=0;
 let totalItemCount=0;
 let napkinQty=0,napkinSubtotal=0;

 allCards.forEach(c=>{
  const id=lineUid(c);
  const q=(id===clickedUid)?targetQty:(pendingQuantities[id]!==undefined?pendingQuantities[id]:(Number(c.querySelector('[data-item-qty]')?.textContent)||0));
  if(q<=0)return;
  totalItemCount+=q;
  const origU=Number(c.dataset.originalUnitPrice||c.dataset.unitPrice)||0;
  const compU=Number(c.dataset.compareUnitPrice)||origU;
  totalSubtotal+=q*origU;
  totalCompare+=q*(compU>origU?compU:origU);
  if(c.dataset.napkinOffer==='true'){napkinQty+=q;napkinSubtotal+=q*origU;}
 });

 // Milestone progress tracks subtotal so discounts never push customer backwards!
 const tier1Threshold=tiers[0]||110000;
 const pct=Math.min(100,Math.max(0,Number(box?.dataset.discountPercent)||0))/100;
 // Mirror Shopify's best-of rule: the napkin offer (fixed amount off 3+ napkin sets, once per order)
 // or the % discount, whichever saves more, never both.
 const napkinMin=Number(box?.dataset.napkinMin)||0,napkinOff=Number(box?.dataset.napkinDiscount)||0;
 const napkinDiscount=napkinMin&&napkinQty>=napkinMin?Math.min(napkinOff,napkinSubtotal):0;
 const pctDiscount=totalSubtotal>=tier1Threshold?Math.round(totalSubtotal*pct):0;
 let blocked,offerDiscount;
 if(napkinDiscount>0||napkinOff>0&&napkinMin>0){blocked=napkinDiscount>0&&napkinDiscount>pctDiscount;offerDiscount=blocked?napkinDiscount:0;}
 else{blocked=tier1Blocked(box);offerDiscount=blocked?Math.min(totalSubtotal,Number(box?.dataset.offerDiscount)||0):0;}
 const isTier1Unlocked=!blocked&&totalSubtotal>=tier1Threshold;
 const napkinShare=c=>blocked&&napkinDiscount>0&&c.dataset.napkinOffer==='true'&&napkinSubtotal>0;

 // Proportional coupon discount (admin-set % if subtotal >= tier1)
 const autoCouponDiscount=isTier1Unlocked?pctDiscount:0;
 const finalGrandTotal=Math.max(0,totalSubtotal-autoCouponDiscount-offerDiscount);
 const mrpDiscount=Math.max(0,totalCompare-totalSubtotal);
 const totalSavings=Math.max(0,totalCompare-finalGrandTotal);

 // Update all cards
 allCards.forEach(c=>{
  const id=lineUid(c);
  const q=(id===clickedUid)?targetQty:(pendingQuantities[id]!==undefined?pendingQuantities[id]:(Number(c.querySelector('[data-item-qty]')?.textContent)||0));
  if(q<=0)return;
  const origU=Number(c.dataset.originalUnitPrice||c.dataset.unitPrice)||0;
  const compU=Number(c.dataset.compareUnitPrice)||origU;
  const isGift=c.classList.contains('cart-item-card--gift')||origU===0;

  // Final line price
  const linePriceEl=c.querySelector('[data-line-price]');
  if(linePriceEl&&!isGift){
   const lineFinal=isTier1Unlocked?Math.round(origU*(1-pct)*q):napkinShare(c)?Math.round(origU*q-napkinDiscount*origU*q/napkinSubtotal):(origU*q);
   linePriceEl.textContent=formatInr(lineFinal);
  }

  // Compare line price
  const comparePriceEl=c.querySelector('[data-compare-line-price]');
  if(comparePriceEl){
   const lineCompare=(compU>origU?compU:origU)*q;
   const currentLinePrice=isTier1Unlocked?Math.round(origU*(1-pct)*q):napkinShare(c)?Math.round(origU*q-napkinDiscount*origU*q/napkinSubtotal):(origU*q);
   if(lineCompare>currentLinePrice){
    comparePriceEl.textContent=formatInr(lineCompare);
    comparePriceEl.style.display='';
   }else{
    comparePriceEl.style.display='none';
   }
  }
 });

 // Rewards Bar & Celebration trigger
 if(box){
  box.dataset.cartTotal=totalSubtotal;
  box.dataset.progressTotal=finalGrandTotal;
  box.dataset.tier1Applied=String(isTier1Unlocked);
  box.dataset.tier1Blocked=String(blocked);
  box.dataset.offerDiscount=String(offerDiscount);
  // Remember the level from before the first tap of a burst, move the bar now, and celebrate only
  // after the taps settle (same 250ms window as the network call), so + then - never flashes a popup.
  if(tapPopTimer===null)tapPopBase=Math.max(confirmedLevel??0,shownLevel??0,previousLevel??0);
  tapPopSavings=autoCouponDiscount>0?formatInr(autoCouponDiscount):offerDiscount>0?formatInr(offerDiscount):formatInr(totalSavings);
  const tapLevel=milestones();
  if(shownLevel!==null&&tapLevel<shownLevel)dismissCelebration();
  clearTimeout(tapPopTimer);
  tapPopTimer=setTimeout(()=>{
   const settled=previousLevel??0;
   if(settled>tapPopBase&&settled!==shownLevel)triggerCelebration(settled,tapPopSavings);
   tapPopTimer=null;tapPopBase=null;
  },250);
 }

 // Counts
 const countEl=document.querySelector('[data-cart-count]');
 if(countEl)countEl.textContent=`(${totalItemCount})`;
 const bubble=document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
 if(bubble)bubble.textContent=totalItemCount;
 const bubbleLabel=document.querySelector('#cart-icon-bubble .cart-count-bubble .visually-hidden');
 if(bubbleLabel)bubbleLabel.textContent=`${totalItemCount} ${totalItemCount===1?'item':'items'}`;

 // Footer totals
 const footerFinal=document.querySelector('[data-footer-final-total]');
 if(footerFinal)footerFinal.textContent=formatInr(finalGrandTotal);

 const footerOld=document.querySelector('[data-footer-old-total]');
 if(footerOld){
  if(totalSavings>0){
   footerOld.textContent=formatInr(totalCompare);
   footerOld.style.display='';
  }else{
   footerOld.textContent='';
   footerOld.style.display='none';
  }
 }

 const footerSavingsRow=document.querySelector('[data-footer-savings-row]');
 const footerSavingsVal=document.querySelector('[data-footer-savings-val]');
 if(footerSavingsRow&&footerSavingsVal){
  if(totalSavings>0){
   footerSavingsVal.textContent=formatInr(totalSavings);
   footerSavingsRow.style.display='';
  }else{
   footerSavingsRow.style.display='none';
  }
 }

 // Coupon Box
 const couponSavingsVal=document.querySelector('[data-coupon-savings-val]');
 if(couponSavingsVal){
  couponSavingsVal.textContent=formatInr(autoCouponDiscount);
 }
 const couponSavingsRow=document.querySelector('.cart-coupon-box__savings-row');
 if(couponSavingsRow){
  couponSavingsRow.style.display=autoCouponDiscount>0?'':'none';
 }
 const couponDetails=document.querySelector('#CartDiscountDetails');
 if(couponDetails&&autoCouponDiscount===0){
  couponDetails.hidden=true;
 }

 // Breakdown Details Accordion
 const breakdownMrp=document.querySelector('[data-breakdown-mrp]');
 if(breakdownMrp)breakdownMrp.textContent=formatInr(totalCompare);

 const breakdownMrpDiscount=document.querySelector('[data-breakdown-mrp-discount]');
 if(breakdownMrpDiscount)breakdownMrpDiscount.textContent=formatInr(mrpDiscount);

 const breakdownCoupon=document.querySelector('[data-breakdown-coupon-discount]');
 if(breakdownCoupon)breakdownCoupon.textContent=formatInr(autoCouponDiscount);

 const breakdownGrand=document.querySelector('[data-breakdown-grand-total]');
 if(breakdownGrand)breakdownGrand.textContent=formatInr(finalGrandTotal);

 const breakdownHeader=document.querySelector('[data-breakdown-header-savings]');
 if(breakdownHeader)breakdownHeader.textContent=`You saved ${formatInr(totalSavings)}!`;

 const breakdownSaved=document.querySelector('[data-breakdown-saved-banner]');
 if(breakdownSaved&&totalCompare>0){
  const pct=((totalSavings/totalCompare)*100).toFixed(1);
  breakdownSaved.textContent=`You Saved ${formatInr(totalSavings)} (${pct}%) so far!`;
 }
}

// Shopify confirmed the cart: celebrate a level the tap didn't already show, close a popup Shopify doesn't back up,
// and refresh the popup's savings with the confirmed figure.
function reconcile(levelBefore){
 const level=milestones();
 const sheet=document.querySelector('#milestone-celebration');
 const active=sheet?.classList.contains('is-active');
 const base=Math.max(levelBefore??0,shownLevel??0);
 if(level>base&&levelBefore!==null)triggerCelebration(level);
 else if(active&&shownLevel!==null&&level<shownLevel)dismissCelebration();
 else if(active){
  const couponVal=document.querySelector('[data-coupon-savings-val]')?.textContent?.trim();
  const footerVal=document.querySelector('[data-footer-savings-val]')?.textContent?.trim();
  const v=couponVal&&couponVal!=='₹ 0.00'?couponVal:footerVal;
  const el=sheet.querySelector('[data-celebration-savings]');if(el&&v)el.textContent=v;
 }
 confirmedLevel=level;
 if(!sheet?.classList.contains('is-active'))shownLevel=null;
 return level;
}

async function render(html,celebrateFrom=null){
 const doc=new DOMParser().parseFromString(html,'text/html');
 const fresh=doc.querySelector('#CartDrawer');
 const old=document.querySelector('#CartDrawer');
 if(!fresh||!old)throw Error('Cart could not refresh. Please reload.');

 const levelBefore=celebrateFrom!==null?Number(celebrateFrom):(confirmedLevel!==null?confirmedLevel:previousLevel);
 const oldCards=old.querySelectorAll('.cart-item-card');
 const freshCards=fresh.querySelectorAll('.cart-item-card');
 const hasEmpty=fresh.querySelector('.drawer__inner-empty')||old.querySelector('.drawer__inner-empty');

 // Micro-DOM Patching if items structure is stable
 if(oldCards.length>0&&oldCards.length===freshCards.length&&!hasEmpty){
  freshCards.forEach((freshCard,idx)=>{
   const oldCard=oldCards[idx];
   if(oldCard){
    const freshKey=freshCard.dataset.lineItemKey;
    const freshId=lineUid(oldCard);
    oldCard.dataset.lineItemKey=freshKey;
    if(freshCard.dataset.unitPrice)oldCard.dataset.unitPrice=freshCard.dataset.unitPrice;
    if(freshCard.dataset.originalUnitPrice)oldCard.dataset.originalUnitPrice=freshCard.dataset.originalUnitPrice;
    if(freshCard.dataset.compareUnitPrice)oldCard.dataset.compareUnitPrice=freshCard.dataset.compareUnitPrice;
    oldCard.querySelectorAll('[data-cart-qty-change]').forEach(btn=>btn.dataset.itemKey=freshKey);
    oldCard.querySelectorAll('[data-cart-remove]').forEach(btn=>btn.dataset.cartRemove=freshKey);

    if(pendingQuantities[freshId]===undefined){
     const freshQty=freshCard.querySelector('[data-item-qty]')?.textContent;
     const oldQty=oldCard.querySelector('[data-item-qty]');
     if(oldQty&&freshQty)oldQty.textContent=freshQty;
     oldCard.style.opacity='1';

     const freshPrice=freshCard.querySelector('[data-line-price]')?.innerHTML;
     const oldPrice=oldCard.querySelector('[data-line-price]');
     if(oldPrice&&freshPrice)oldPrice.innerHTML=freshPrice;

     const freshOldPrice=freshCard.querySelector('[data-compare-line-price]')?.innerHTML;
     const oldOldPrice=oldCard.querySelector('[data-compare-line-price]');
     if(oldOldPrice){
      if(freshOldPrice){
       oldOldPrice.innerHTML=freshOldPrice;
       oldOldPrice.style.display='';
      }else{
       oldOldPrice.style.display='none';
      }
     }
    }
   }
  });

  const oldCouponBox=old.querySelector('[data-cart-coupon-box]');
  const freshCouponBox=fresh.querySelector('[data-cart-coupon-box]');
  if(oldCouponBox&&freshCouponBox&&Object.keys(pendingQuantities).length===0){
   const oldSavingsRow=oldCouponBox.querySelector('.cart-coupon-box__savings-row');
   const freshSavingsRow=freshCouponBox.querySelector('.cart-coupon-box__savings-row');
   if(oldSavingsRow&&freshSavingsRow)oldSavingsRow.style.display=freshSavingsRow.style.display;

   const oldVal=oldCouponBox.querySelector('[data-coupon-savings-val]');
   const freshVal=freshCouponBox.querySelector('[data-coupon-savings-val]');
   if(oldVal&&freshVal)oldVal.innerHTML=freshVal.innerHTML;

   const oldDet=oldCouponBox.querySelector('#CartDiscountDetails');
   const freshDet=freshCouponBox.querySelector('#CartDiscountDetails');
   if(oldDet&&freshDet)oldDet.innerHTML=freshDet.innerHTML;
  }

  const oldFooter=old.querySelector('.drawer__footer-wrap');
  const freshFooter=fresh.querySelector('.drawer__footer-wrap');
  if(oldFooter&&freshFooter&&Object.keys(pendingQuantities).length===0){
   const oldFinal=oldFooter.querySelector('[data-footer-final-total]');
   const freshFinal=freshFooter.querySelector('[data-footer-final-total]');
   if(oldFinal&&freshFinal)oldFinal.innerHTML=freshFinal.innerHTML;

   const oldOld=oldFooter.querySelector('[data-footer-old-total]');
   const freshOld=freshFooter.querySelector('[data-footer-old-total]');
   if(oldOld&&freshOld){oldOld.innerHTML=freshOld.innerHTML;oldOld.style.display=freshOld.style.display;}

   const oldRow=oldFooter.querySelector('[data-footer-savings-row]');
   const freshRow=freshFooter.querySelector('[data-footer-savings-row]');
   if(oldRow&&freshRow){oldRow.innerHTML=freshRow.innerHTML;oldRow.style.display=freshRow.style.display;}

   const oldBrk=oldFooter.querySelector('.cart-total-breakdown');
   const freshBrk=freshFooter.querySelector('.cart-total-breakdown');
   if(oldBrk&&freshBrk){
    const wasOpen=oldBrk.hasAttribute('open');
    const oldBdy=oldBrk.querySelector('.cart-total-breakdown__body');
    const freshBdy=freshBrk.querySelector('.cart-total-breakdown__body');
    if(oldBdy&&freshBdy)oldBdy.innerHTML=freshBdy.innerHTML;
    if(wasOpen)oldBrk.setAttribute('open','');
   }
  }

  const oldRew=old.querySelector('[data-cart-rewards]');
  const freshRew=fresh.querySelector('[data-cart-rewards]');
  if(oldRew&&freshRew&&Object.keys(pendingQuantities).length===0){
   oldRew.dataset.cartTotal=freshRew.dataset.cartTotal;
   ['progressTotal','offerDiscount','tier1Blocked','tier1Applied'].forEach(k=>{if(freshRew.dataset[k]!==undefined)oldRew.dataset[k]=freshRew.dataset[k];});
  }

  const count=fresh.querySelector('[data-cart-count]')?.textContent.replace(/[^0-9]/g,'')||'0';
  const countEl=old.querySelector('[data-cart-count]');
  if(countEl&&Object.keys(pendingQuantities).length===0)countEl.textContent=`(${count})`;
  const bubble=document.querySelector('#cart-icon-bubble .cart-count-bubble span');
  if(bubble&&Object.keys(pendingQuantities).length===0)bubble.textContent=count;

  clearStatus();
  if(Object.keys(pendingQuantities).length===0)reconcile(levelBefore);
  else milestones();
 } else {
  // Structural changes (items added, removed, empty state)
  const pos=old.querySelector('.cart-drawer__scroll')?.scrollTop||0;
  old.innerHTML=fresh.innerHTML;
  const scroller=old.querySelector('.cart-drawer__scroll');
  if(scroller)scroller.scrollTop=pos;
  const count=old.querySelector('[data-cart-count]')?.textContent.replace(/[^0-9]/g,'')||'0';
  document.querySelector('cart-drawer')?.classList.toggle('is-empty',count==='0');
  const bubble=document.querySelector('#cart-icon-bubble .cart-count-bubble span');
  if(bubble)bubble.textContent=count;
  clearStatus();
  if(Object.keys(pendingQuantities).length===0)reconcile(levelBefore);
  else milestones();
 }
}

function renderCartIcon(html){
 if(!html)return;
 const target=document.querySelector('#cart-icon-bubble');
 if(!target)return;
 const doc=new DOMParser().parseFromString(html,'text/html');
 const source=doc.querySelector('.shopify-section')||doc.body;
 target.innerHTML=source.innerHTML;
}

function publishCartState(cartData,source='cart-drawer'){
 if(typeof publish!=='function'||typeof PUB_SUB_EVENTS==='undefined'||!PUB_SUB_EVENTS.cartUpdate)return;
 publish(PUB_SUB_EVENTS.cartUpdate,{source,cartData,cartDrawerAlreadyRendered:true});
}

async function refresh(celebrateFrom=null){
 const [sectionsResponse,cartResponse]=await Promise.all([
  fetch(root+'?sections=cart-drawer,cart-icon-bubble'),
  fetch(root+'cart.js',{headers:{Accept:'application/json'}})
 ]);
 if(!sectionsResponse.ok||!cartResponse.ok)throw Error('Unable to refresh cart');
 const sections=await sectionsResponse.json();
 const cartData=await cartResponse.json();
 await render(sections['cart-drawer'],celebrateFrom);
 renderCartIcon(sections['cart-icon-bubble']);
 publishCartState(cartData);
}

async function change(endpoint,payload,options={}){
 const isCurrent=typeof options.isCurrent==='function'?options.isCurrent:()=>true;
 try{
  const res=await fetch(root+endpoint,{
   method:'POST',
   headers:{'Content-Type':'application/json',Accept:'application/json'},
   body:JSON.stringify({...payload,sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})
  });
  const data=await res.json();
  if(!isCurrent())return res.ok;
  if(!res.ok){
   await refresh();
   return false;
  }
   if(data.sections?.['cart-drawer']){
    await render(data.sections['cart-drawer']);
    renderCartIcon(data.sections['cart-icon-bubble']);
    publishCartState(data);
   }else await refresh();
   return true;
 }catch(err){
  if(isCurrent())await refresh();
  return false;
 }
}

document.addEventListener('click',e=>{
 const dismissButton=e.target.closest?.('[data-celebration-dismiss]');
 if(e.target.matches?.('#milestone-celebration')||dismissButton){
  e.preventDefault();
  dismissCelebration();
 }
},true);

document.addEventListener('click',async e=>{

 // 1. Optimistic Stepper with Debounced Queue
 const step=e.target.closest('[data-cart-qty-change]');
 if(step){
  e.preventDefault();
  if(step.disabled)return;
  const card=step.closest('.cart-item-card');
  const itemKey=step.dataset.itemKey;
  if(!card||!itemKey)return;
  const itemId=lineUid(card);

  const currentDisplayQty=Number(card.querySelector('[data-item-qty]')?.textContent)||0;
  const currentWorkingQty=pendingQuantities[itemId]!==undefined?pendingQuantities[itemId]:currentDisplayQty;
  const delta=Number(step.dataset.cartQtyChange)||0;
  const targetQty=Math.max(0,currentWorkingQty+delta);
  if(targetQty===currentWorkingQty)return;

  pendingQuantities[itemId]=targetQty;
  const requestVersion=(quantityRequestVersions[itemId]||0)+1;
  quantityRequestVersions[itemId]=requestVersion;

  // Update quantity immediately; Shopify's response remains the source of truth for prices and discounts.
  const qtyEl=card.querySelector('[data-item-qty]');
  if(qtyEl)qtyEl.textContent=targetQty;
  // Instant feedback: run the existing drawer math right away so the reward bar and totals move with the tap.
  // Shopify's response still overwrites everything once it arrives.
  try{syncOptimisticCart(card,itemKey,targetQty);}catch(err){}

  // Debounced Network Dispatch (250ms window)
  clearTimeout(pendingChangeTimers[itemId]);
  pendingChangeTimers[itemId]=setTimeout(async ()=>{
   const qtyToSend=pendingQuantities[itemId];
   // The card's own key, kept current by render() even when Shopify re-keys the line.
   const currentKey=card.dataset.lineItemKey||itemKey;
   if(!card.isConnected){delete pendingQuantities[itemId];delete pendingChangeTimers[itemId];await refresh();return;}
   delete pendingQuantities[itemId];
   delete pendingChangeTimers[itemId];
   const req=change('cart/change.js',{id:currentKey,quantity:qtyToSend},{isCurrent:()=>quantityRequestVersions[itemId]===requestVersion});
   inFlightChanges[itemId]=req;
   try{await req;}finally{if(inFlightChanges[itemId]===req)delete inFlightChanges[itemId];}
  },250);
  return;
 }

 // 2. Item Removal
 const remove=e.target.closest('[data-cart-remove]');
 if(remove){
  e.preventDefault();
  const card=remove.closest('.cart-item-card');
  if(card){
   const uid=lineUid(card);
   clearTimeout(pendingChangeTimers[uid]);delete pendingChangeTimers[uid];delete pendingQuantities[uid];
   quantityRequestVersions[uid]=(quantityRequestVersions[uid]||0)+1;
   if(remove.dataset.removing)return;remove.dataset.removing='1';
   card.style.opacity='0.35';
   card.setAttribute('aria-busy','true');
   card.style.pointerEvents='none';
   try{
    // A quantity change still on its way re-keys the line; wait for it so the remove uses the current key.
    if(inFlightChanges[uid]){try{await inFlightChanges[uid];}catch(err){}}
    let ok=await change('cart/change.js',{id:card.dataset.lineItemKey||remove.dataset.cartRemove,quantity:0});
    // Shopify rejects an old key (400). change() has refreshed the drawer, so retry once with the fresh key.
    if(!ok&&card.isConnected)await change('cart/change.js',{id:card.dataset.lineItemKey||remove.dataset.cartRemove,quantity:0});
   }finally{
    // Never leave the item locked: if it is still in the cart, make it tappable again.
    if(card.isConnected){
     card.style.opacity='1';
     card.removeAttribute('aria-busy');
     card.style.pointerEvents='';
     delete remove.dataset.removing;
    }
   }
   return;
  }
  await change('cart/change.js',{id:remove.dataset.cartRemove,quantity:0});
  return;
 }

 // 3. Quick-Add
 const add=e.target.closest('[data-quick-add]');
 if(add){
  e.preventDefault();
  if(add.disabled)return;
  add.disabled=true;
  const origText=add.textContent;
  add.textContent='ADDING…';
  try{
   await change('cart/add.js',{items:[{id:Number(add.dataset.quickAdd),quantity:1}]});
  }finally{
   if(add.isConnected){
    add.disabled=false;
    add.textContent=origText;
   }
  }
  return;
 }

 // 4. Recommendations Carousel Scroll
 const nav=e.target.closest('[data-rec-prev],[data-rec-next]');
 if(nav){
  e.preventDefault();
  const grid=nav.closest('.cart-recs-box').querySelector('[data-rec-grid]');
  if(grid)grid.scrollBy({left:grid.clientWidth*(nav.hasAttribute('data-rec-prev')?-1:1),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
  return;
 }

 // 5. Coupon Box Toggle
 const toggle=e.target.closest('[data-coupon-toggle]');
 if(toggle){
  const details=document.querySelector('[data-discount-details]');
  if(details){details.hidden=!details.hidden;toggle.setAttribute('aria-expanded',String(!details.hidden));}
  return;
 }

 // 6. Coupon Apply
 if(e.target.closest('[data-coupon-apply]')){
  e.preventDefault();
  const code=document.querySelector('[data-coupon-input]')?.value.trim();
  if(!code){message('Enter a coupon code first.');return;}
  await change('cart/update.js',{discount:code});
  message('Coupon checked. Eligible discounts are reflected in your cart and checkout.');
 }
});

document.addEventListener('keydown',e=>{
 if(e.key==='Escape'&&document.querySelector('#milestone-celebration.is-active'))dismissCelebration();
});

document.addEventListener('cart:updated',event=>{
 if(Object.keys(pendingQuantities).length===0)confirmedLevel=milestones(event.detail?.celebrateFrom??null);
});

new MutationObserver(ms=>{
 if(ms.some(m=>[...m.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('[data-cart-rewards]')||n.querySelector?.('[data-cart-rewards]')))))milestones();
}).observe(document.documentElement,{childList:true,subtree:true});

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{confirmedLevel=milestones();});else confirmedLevel=milestones();
})();
